<div class="flex gap-3">
  <div
    class="drop-area p-2 border-1 surface-border border-round flex-1 overflow-hidden"
    pDroppable
    (onDrop)="drop()"
  >
    <p class="text-center surface-border border-bottom-1">Liste de médias</p>

    <div
      class="overflow-scroll h-20rem"
      #scrollableRef
    >
      @if (floatingAssistantChatService.selectedMediaItems.length === 0) {
        <p class="text-center align-items-center">
          <i class="fa fa-info-circle"></i> Glissez-déposez des médias (articles, podcast, ...) ici
        </p>
      } @else {
        <ul class="list-none flex flex-column gap-2 p-1 m-0">
          @for (item of floatingAssistantChatService.selectedMediaItems; track item) {
            <li class="p-2 border-round shadow-1 flex align-items-center justify-content-between">
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ item.title }}</div>
              <button
                class="p-button p-button-text p-button-sm p-button-danger"
                type="button"
                (click)="removeItem(item.id)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>
